import { format } from "date-fns";

import { ICupomEvento } from "interfaces/cupom";
import checkout from "./forms";

const {
  formField: {
    codigoPromocional,
    dataInicio,
    validade,
    qtdCupom,
    disponivel,
    tipoPorcentagem,
    valorCupom,
    eventoId,
    colorField,
  },
} = checkout;

const initialValuesEdit = (data: ICupomEvento | null) => {
  return {
    [codigoPromocional.name]: data.codigoPromocional.toUpperCase() || "",
    [dataInicio.name]:
      format(
        data.dataInicio.slice(0, 10).concat("T23:59:59.000Z"),
        "yyy-MM-dd"
      ) || "",
    [validade.name]:
      format(
        data.validade.slice(0, 10).concat("T23:59:59.000Z"),
        "yyy-MM-dd"
      ) ||
      data.validade ||
      "",
    [qtdCupom.name]: data.qtdCupom || "",
    [disponivel.name]: data.disponivel || "",
    [tipoPorcentagem.name]: data.tipoPorcentagem ? "Sim" : "Não",
    [valorCupom.name]: data.valorCupom || "",
    [eventoId.name]: data.evento || null,
    [colorField.name]: data.colorField || "",
  };
};

const initialValues = {
  [codigoPromocional.name]: "",
  [dataInicio.name]: format(new Date(), "yyyy-MM-dd"),
  [validade.name]: "",
  [qtdCupom.name]: "",
  [disponivel.name]: 0,
  [tipoPorcentagem.name]: "Sim",
  [valorCupom.name]: "",
  [eventoId.name]: null as { id: number; titulo: string } | null,
  [colorField.name]: "",
};

export { initialValues, initialValuesEdit };
